export default __webpack_public_path__ + "static/media/rocketBackground.7e0ef8d5.png";